import { React, useState } from 'react';
// import IntlMessages from '@iso/components/utility/intlMessages';
import Box from '@iso/components/utility/box';
import ContentHolder from '@iso/components/utility/contentHolder';
import Button from '@iso/components/uielements/button';
import { useContext } from 'react';
import { Form, Input, Switch, Checkbox } from 'antd';
// import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
// import closeIcon from '@iso/assets/images/icon/close-icon.svg';
import closeIcon from '@iso/assets/images/icon/07-icon.svg';
import styled, { createGlobalStyle } from 'styled-components';
import { SelectOption } from '@iso/components/uielements/select';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/ContextProvider';
// import CreateTaskHeader from '../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
// import { borderRadius } from '../../library/helpers/style_utils';
import Select from '../Deployments/Deployment.styles';
import { formatErrors, hasPermission, isValidBool, isValidListString, isValidMapAny, isValidMapString } from '../../context/helper';
import CustomInfoTooltip from '../Dashboard/CustomComponents/CustomInfoTooltip';
import api from '../../api';
import { AlertContext } from '../../context/alertContext';
// import useProject from '../../Dashboard/CustomHooks/useProject';
// import useEnvironmentVariables from '../Dashboard/CustomHooks/useEnvironmentVariables';
// import Checkbox from '@iso/components/uielements/checkbox';
// import { DeploymentContext } from '../../context/deploymentContext';



const Option = SelectOption;
const { TextArea } = Input

const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }

  .isoHelperText {
    color: red;
    font-weight: 400;
    font-size: 12px;
    margin-top: 10%;
    display: flex;
    justify-content: start;
  }

  .header-text{
    font-size: 14px;
  }
`;

// const addButtonStyle = {
//     marginRight: "10px",
//     fontSize: "25px"
// };

let titleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontSize: "16px",
    fontWeight: "500"
}

let subTitleStyle = {
    fontSize: "14px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontType: "regular",
    fontWeight: "400"
}

// let boxStyle = {
//     border: '0',
//     padding: "0",
//     width: "100%",
// }

export default ({
    // handleSubmit,
    data,
    allData,
    update,
    service,
    type,
    applicationsList,
    // currentProject,
    hasChanges,
    fromWorkflow,
    fromApplicationBlueprint,
    sourceType,
    setEnvVarsList,
    excludeDependentApplicationName,
}) => {


    const { openRightDrawer, setOpenRightDrawer } = useContext(AppContext);
    const [form] = Form.useForm();

    const [envData, setEnvData] = useState(update ?
        { ...data, value: hasPermission('view_secret') && data.isSecret ? data.value : !data.isSecret ? data.value : "********", lastAction: "Update" }
        : {
            varName: "",
            valueFrom: fromWorkflow ? "Value" : (fromApplicationBlueprint ? "" : ""),
            valueShown: "",
            value: "",
            originalKey: "", // original key value -> used when updating a variable. This key will be sent
            lastAction: "", // Update, Delete, "" -> last action performed on a particular variable
            isSecret: false,//(!hasPermission('create_secret') && currentProject.accountDetails.account_id) ? false : true,
            isHide: false,//(!hasPermission('create_secret') && currentProject.accountDetails.account_id) ? false : true,
            dependOn: "",
            value_depend_on: "",
            error: false,
            importFrom: "",
            isNew: true,
            syncProj: false,//(!hasPermission('create_secret') && currentProject.accountDetails.account_id) ? false : true,
            injectAt: fromApplicationBlueprint ? [] : (fromWorkflow ? ["Build Time"] : [])
        });
    // const [myDropdown, setMyDropdown] = useState([]);
    const [error, setError] = useState({
        status: false,
        msg: "Success"
    });
    // const [searchValue, setSearchValue] = useState("");
    // const [savingVars, setSavingVars] = useState(false);
    const { set_alertOptions } = useContext(AlertContext);
    
    const [selectedApplicationId, setSelectedApplicationId] = useState(null);
    const [applicationsLoading, setApplicationsLoading] = useState(false);
    const [valueFromDropdown, setValueFromDropdown] = useState([]);
    const [myDropdown, setMyDropdown] = useState([]);
    
    // Value From options for Application Blueprint
    const valueFroms = fromApplicationBlueprint ? ["Value", "Value From"] : [];
    let myValueFroms = [];
    valueFroms.map((child, ind) => {
        myValueFroms.push(<Option key={child} name="valueFrom" value={child}>{child}</Option>);
    });
    // const { encryptSecrets, decryptSecrets } = useProject();
    // const { addEnvPayloadGen, updateEnvPayloadGen } = useEnvironmentVariables(currentProject);

    // const { updateDep } = useContext(DeploymentContext);

    //console.log("Data: ", data);

    // const navigate = useNavigate();
    const location = useLocation();
    const navigate = useNavigate();

    // shifter here from top
    //   const valueFroms = fromWorkflow ? ["Value"] : ["Value", "Value From"];
    //   let myValueFroms = [];
    //   valueFroms.map((child, ind) => {
    //     myValueFroms.push(<Option key={child} name="valueFrom" value={child}>{child}</Option>);
    //   });

    //   useEffect(() => {
    //     // const rawValues = ["DB.HOST", "DB.USER", "DB.PASSWORD"];
    //     console.log("service :", valueFromDropdown, location);
    //     let myValues = [];
    //     valueFromDropdown.map((temp, ind) => {
    //       // if (temp.service_category_id !== 8) {
    //       //   temp.connection_parameters.map((child) => {
    //       //     myValues.push(<Option key={child} name="value" data-alias={temp.id} my-value={child} value={child}>{child}</Option>);
    //       //   });
    //       // }
    //       // else {
    //       console.log("values: ", temp.connection_parameters);
    //       Object.keys(temp.connection_parameters).map((child) => {
    //         console.log("temp val: ", temp.id, child);
    //         myValues.push(<Option key={child + "_" + temp.name} name="value" data-alias={temp.id} my-value={child} value={child + "_" + temp.name}>
    //           <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
    //             <p style={{ color: "#1f1f1f", fontWeight: "600", fontFamily: "Nunito Sans" }}>{child + "_" + temp.name}</p>
    //             <div style={{ marginTop: "10px", whiteSpace: "normal" }}>
    //               <p style={{ marginRight: "10px", fontFamily: "Nunito Sans", fontSize: "12px" }}>{temp.connection_parameters[child].Description}</p>
    //               <p style={{ color: "#4D99EF", fontFamily: "semibold", fontFamily: "Nunito Sans" }}>{temp.connection_parameters[child].Example}</p>
    //             </div>
    //           </div>
    //         </Option>)
    //       });
    //       //}
    //     });
    //     setMyDropdown(myValues);
    //   }, []);

    useEffect(() => {
        if (form) {
            form.setFieldsValue({ ...envData });
        }
    }, [envData]);

    useEffect(() => {
        if (update && form) {
            try {
                const values = form.validateFields();
                console.log('Success:', values);
            }
            catch (err) {
                console.log('Error :', err);
            }
        }
    }, [update]);

    // Initialize selectedApplicationId from update data if it exists
    useEffect(() => {
        if (fromApplicationBlueprint && update && data && data.dependOn) {
            setSelectedApplicationId(data.dependOn);
        }
    }, [update, data, fromApplicationBlueprint]);

    // Fetch environment variables from selected application
    useEffect(() => {
        if (fromApplicationBlueprint && selectedApplicationId && envData.valueFrom === "Value From") {
            // fetchApplicationEnvVars(selectedApplicationId);
            getDropDownData(selectedApplicationId);
        }
    }, [selectedApplicationId, fromApplicationBlueprint, envData.valueFrom]);

    // Build dropdown options from valueFromDropdown
    // useEffect(() => {
    //     if (fromApplicationBlueprint && valueFromDropdown?.connection_parameters && selectedApplicationId) {
    //         console.log("service :", valueFromDropdown, location);
    //         let myValues = [];
    //         valueFromDropdown.map((temp, ind) => {
    //             console.log("values: ", temp.connection_parameters);

    //             Object.keys(temp.connection_parameters).map((child) => {
    //                 console.log("temp val: ", temp.id, child);
    //                 myValues.push(<Option key={child + "_" + temp.name} name="value" data-alias={temp.id} my-value={child} value={child + "_" + temp.name}>
    //                     <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
    //                         <p style={{ color: "#1f1f1f", fontWeight: "600", fontFamily: "Nunito Sans" }}>{child + "_" + temp.name}</p>
    //                         <div style={{ marginTop: "10px", whiteSpace: "normal" }}>
    //                         <p style={{ marginRight: "10px", fontFamily: "Nunito Sans", fontSize: "12px" }}>{temp.connection_parameters[child].Description}</p>
    //                         <p style={{ color: "#4D99EF", fontFamily: "semibold", fontFamily: "Nunito Sans" }}>{temp.connection_parameters[child].Example}</p>
    //                         </div>
    //                     </div>
    //                 </Option>);
    //             });
    //         });
    //         setMyDropdown(myValues);

    //         // let myValues = [];
    //         // valueFromDropdown.forEach((envVar) => {
    //         //     myValues.push(
    //         //         <Option key={envVar.varName} name="value" data-alias={selectedApplicationId} my-value={envVar.varName} value={`${envVar.varName}_${selectedApplicationId}`}>
    //         //             {envVar.varName}
    //         //         </Option>
    //         //     );
    //         // });
    //         // setMyDropdown(myValues);
    //     } else {
    //         setMyDropdown([]);
    //     }
    // }, [valueFromDropdown, selectedApplicationId, fromApplicationBlueprint]);

    const getDropDownData = (id) => {
        // dispatch({ loader: "envLoad", status: "loading" });
        // Get ValueFrom DropDown Data
        api.get(`${process.env.REACT_APP_API_URI}/api/project_env/${id}/service-categories-parameters/`)
            .then((res) => {
                let data = res.data;
                console.log("service-categories-parameters data :", data);
                if (data.status) {
                    let myValues = [];
                    let temp = data.data;
                    Object.keys(data.data?.connection_parameters).map((child) => {
                        console.log("temp val: ", temp.id, child);
                        myValues.push(<Option key={child + "_" + temp.name} name="value" data-alias={temp.id} my-value={child} value={child + "_" + temp.name}>
                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                                <p style={{ color: "#1f1f1f", fontWeight: "600", fontFamily: "Nunito Sans" }}>{child + "_" + temp.name}</p>
                                <div style={{ marginTop: "10px", whiteSpace: "normal" }}>
                                <p style={{ marginRight: "10px", fontFamily: "Nunito Sans", fontSize: "12px" }}>{temp.connection_parameters[child].Description}</p>
                                <p style={{ color: "#4D99EF", fontFamily: "semibold", fontFamily: "Nunito Sans" }}>{temp.connection_parameters[child].Example}</p>
                                </div>
                            </div>
                        </Option>);
                    });
                    
                    setMyDropdown(myValues);
                }
                else {
                    let err = formatErrors(data.error_details);
                    console.log("Err :", err);
                    if(err === "You do not have permission to perform this action."){
                        toggleAlert("error", "Error", err);
                        // dispatch({ loader: "envLoad", status: "loaded" });
                        navigate('/all-projects');
                    }
                    else if(err === "You do not have permission to view this Project."){
                        toggleAlert("error", "Error", err);
                        // dispatch({ loader: "envLoad", status: "loaded" });
                        navigate('/');
                    }
                }
            })
            .catch((err) => {
                console.log("err :", err);
                // dispatch({ loader: "envLoad", status: "loaded" });
            });
    }

    // const fetchApplicationEnvVars = async (applicationId) => {
    //     try {
    //         const response = await api.get(`${process.env.REACT_APP_API_URI}/api/project_env/services/get-application/${applicationId}/`);
    //         console.log("response: ", response.data);
    //         if (response.data.status && response.data.data) {
    //             const config = response.data.data.configuration || {};
    //             const envVars = config.environment_variables || {};
                
    //             console.log("envVars: ", envVars);
    //             // Transform to format expected by dropdown
    //             const transformedEnvVars = Object.keys(envVars).map((varName) => ({
    //                 varName: varName,
    //                 value: envVars[varName]?.value || '',
    //             })).filter((env) => env.varName);
                
    //             console.log("transformedEnvVars: ", transformedEnvVars);
    //             setValueFromDropdown(transformedEnvVars);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching application environment variables:", error);
    //         setValueFromDropdown([]);
    //     }
    // };

    const handleValueFromSelect = (value) => {
        setEnvData({
            ...envData,
            valueFrom: value,
            value: value === "Value From" ? "" : envData.value,
            valueShown: value === "Value From" ? "" : envData.valueShown,
            dependOn: value === "Value From" ? "" : envData.dependOn,
            isSecret: value === "Value From" ? false : envData.isSecret,
            isHide: value === "Value From" ? false : envData.isHide,
        });
        form.setFieldValue("valueFrom", value);
        if (value === "Value From") {
            form.setFieldValue("value", "");
            setSelectedApplicationId(null);
        }
    };

    const handleServiceSelect = (applicationId) => {
        setSelectedApplicationId(applicationId);
        setEnvData({
            ...envData,
            dependOn: applicationId,
            value: "",
            valueShown: "",
        });
        form.setFieldValue("value", "");
    };

    const handleSelectChange = (value, option) => {
        if (option && option.props) {
            const name = option.props.name;
            if (name === "value") {
                const actualValue = option.props["my-value"];
                const appId = option.props["data-alias"];
                setEnvData({
                    ...envData,
                    value: actualValue,
                    valueShown: value,
                    dependOn: appId,
                    error: value ? false : true
                });
                form.setFieldValue("value :", actualValue);
            }
        }
        setError({ ...error, status: false });
    };

    const handelClick = () => {
        console.log("location.state: ", location.state);
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
                columnId: ""
            },
        });
    }

    const handelInputChange = (e) => {
        console.log("inside handelInputChange");
        let val = e.target.value;
        if (e.target.name === "value" && ["map(any)", "map(string)", "any", "list(string)"].includes(envData.type)) {
            // pass
        }
        else {
            val = val.replace(/\s/g, '');
        }

        if (e.target.name === "value") {
            console.log("Env data: ", envData);
            setEnvData({
                ...envData,
                [e.target.name]: val,
                dependOn: null,
                error: val ? false : true
            });

        }
        else {
            if (e.target.name === "varName") {
                if (!update) {
                    setEnvData({ ...envData, [e.target.name]: val, error: val ? false : true, originalKey: val });
                }
                else {
                    setEnvData({ ...envData, [e.target.name]: val, error: val ? false : true });
                }
            }
            else {
                setEnvData({ ...envData, [e.target.name]: val, error: val ? false : true });
            }
        }
        form.setFieldValue(e.target.name, val);
        setError({ ...error, status: false });
    }

    const handelCreate = async (e, addAnother) => {
        console.log("inside handelCreate envData:", envData, location.state);
        // console.log("inside handelCreate currentProject:", currentProject);
        try {
            if (form) {
                const values = await form.validateFields();
                console.log('Success:', values);
            }
            let allNames = [];
            console.log("My service: ", service);
            if (data) {
                data.map((temp) => {
                    if(temp.lastAction !== "Delete") {
                        allNames.push(temp.varName);
                    }
                });
            }

            if (allNames.includes(envData.varName)) {
                setError({
                    status: true,
                    msg: "Variable name already exist. Please provide unique variable name."
                });
                form.setFields([{
                    name: "varName",
                    errors: ["Variable name already exist. Please provide unique variable name."]
                }]);
            }
            else if (envData.varName.startsWith(" ") || envData.varName.endsWith(" ")) {
                setError({
                    status: true,
                    msg: "Please remove any leading or trailing spaces from variable name."
                });
            }
            else {
                setError({ ...error, status: false });

                console.log("data while add: ", data);
                console.log("envData while add: ", envData);
                data.unshift(envData);
                console.log("updated data while add: ", data);

                setEnvVarsList([...data]);

                if (addAnother) {
                    setEnvData({
                        varName: "",
                        valueFrom: "",
                        value: "",
                        isSecret: envData.isSecret,
                        isHide: true,
                        dependOn: "",
                        value_depend_on: "",
                        error: false,
                        originalKey: "", // original key value -> used when updating a variable. This key will be sent
                        lastAction: "", // Update, Delete, "" -> last action performed on a particular variable
                        isHide: true,
                        importFrom: "",
                        isNew: true,
                        syncProj: false,
                        injectAt: fromWorkflow ? ["Build Time"] : [],
                    });
                }
                else {
                    console.log("my click");
                    handelClick();
                }
            }
        }
        catch (err) {
            const firstErrorField = err?.errorFields?.[0]?.name;
            if (firstErrorField && form.scrollToField) {
                form.scrollToField(firstErrorField, { behavior: "smooth", block: "center" });
            } else if (typeof window !== "undefined" && window.scrollTo) {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
            console.log("Inside handelCreate Error :", err);
        };
    }

    const handelUpdate = async (e) => {
        console.log("inside handelUpdate envData:", service, envData, data, location.state);
        try {
            // const values = await form.validateFields();
            // console.log('Success:', values);
            if (form) {
                const values = await form.validateFields();
                console.log('Success:', values);
            }
            let allNames = [];
            let ctr = 0; //counts how many times the variables get repeated
            // if (fromEnvironment) {
            console.log("Environment data: ", service.envs);

            allData?.filter((temp) => temp.lastAction !== "Delete")?.map((temp) => {
                // check if the key of the variable was changed. 
                // If it gets changed, compare the variables with varName(updated key) for variables and original key for the edited variable.
                if (temp.varName != envData.varName && temp.varName !== envData.originalKey) {
                    allNames.push(temp.varName);
                }
                else {
                    allNames.push(temp.varName);
                    ctr++;
                }
            });
            // }
            // else {
            //   if (service) {
            //     service.envs.map((temp) => {
            //       if (temp.varName != data.varName) {
            //         allNames.push(temp.varName);
            //       }
            //     });
            //   } 
            // }

            console.log("ALL NAMES: ", allNames, allNames.includes(envData.varName), ctr);

            if (allNames.includes(envData.varName) && ctr > 1) {
                setError({
                    status: true,
                    msg: "Variable name already exist. Please provide unique variable name."
                });
                form.setFields([{
                    name: "varName",
                    errors: ["Variable name already exist. Please provide unique variable name."]
                }]);
            }
            else if (envData.varName.startsWith(" ") || envData.varName.endsWith(" ")) {
                setError({
                    status: true,
                    msg: "Please remove any leading or trailing spaces from variable name."
                });
            }
            else {
                setError({ ...error, status: false });
                console.log("Data.tempId: ", data);

                // update env_var here
                console.log("data while update: ", data);
                console.log("envData while update: ", envData);
                allData[data.id] = { ...envData };

                console.log("updated allData while update: ", allData);

                setEnvVarsList([...allData]);

                handelClick();
            }
            // }
        }
        catch (err) {
            const firstErrorField = err?.errorFields?.[0]?.name;
            if (firstErrorField && form.scrollToField) {
                form.scrollToField(firstErrorField, { behavior: "smooth", block: "center" });
            } else if (typeof window !== "undefined" && window.scrollTo) {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
            console.log("Inside handelCreate Error :", err);
        }
    }

    function toggleAlert(type, message, description) {

        set_alertOptions(alertOptions => ({
            status: true,
            type: type,
            message: message,
            description: description,
        }));

        // opacity=0 after 10sec
        setTimeout(() => {
            set_alertOptions(alertOptions => ({
                status: false,
                type: type,
                message: message,
                description: description,
            }));
        }, 5 * 1000);
    }

    // const handelSaveEnvVar = async (callSecretApi) => {
    //     let payload = [];
    //     // let myAppIdx = [];
    //     let foundEmpty = false;
    //     let injectFilled = true;
    //     if (update) {
    //         payload = updateEnvPayloadGen(callSecretApi, foundEmpty);
    //     }
    //     else {
    //         payload = addEnvPayloadGen(callSecretApi, foundEmpty, envData);
    //     }
    //     console.log("Entering check...", callSecretApi);
    //     console.log("My payload: ", payload);
    //     if (payload.length > 0 && !fromWorkflow) {
    //         console.log("My secret api: ", callSecretApi, payload, data);
    //         !callSecretApi && !fromEnvironment ? api.put(`${process.env.REACT_APP_API_URI}/api/project_env/projects/${currentProject.id}/services-envs/`, payload.filter((val) => !fromEnvironment ? val.id === currentProject.tasks[selectedAppId].serviceId : (val.id === data.serviceId || val.id === data.tempId)))
    //             .then((res) => {
    //                 let data = res.data;
    //                 console.log("repo/list data :", data);
    //                 if (data.status) {
    //                     toggleAlert("success", "Success", update ? "Environment variable updated successfully." : "Environment variable added successfully.");
    //                     setHasChanges(false);
    //                 }
    //                 else {
    //                     let err = formatErrors(data.msg);
    //                     toggleAlert("error", "Error", err);
    //                 }
    //                 setSavingVars(false);
    //             })
    //             .catch((err) => {
    //                 console.log("err :", err);
    //                 toggleAlert("error", "Error", "Something went wrong. Please try again.");
    //                 setSavingVars(false);
    //             }) :
    //             !update && callSecretApi ? api.post(`${process.env.REACT_APP_API_URI}/api/project_env/secrets`, payload.find(val => !fromEnvironment ? val.id === currentProject.tasks[selectedAppId].serviceId : (val.id === data.serviceId || val.id === data.tempId)))
    //                 .then((res) => {
    //                     let data = res.data;
    //                     console.log("repo/list data :", data);
    //                     if (data.status) {
    //                         toggleAlert("success", "Success", update ? "Environment variable updated successfully." : "Environment variable added successfully.");
    //                         setHasChanges(false);
    //                     }
    //                     else {
    //                         let err = formatErrors(data.msg);
    //                         toggleAlert("error", "Error", err);
    //                     }
    //                     setSavingVars(false);
    //                 })
    //                 .catch((err) => {
    //                     console.log("err :", err);
    //                     toggleAlert("error", "Error", "Something went wrong. Please try again.");
    //                     setSavingVars(false);
    //                 }) : callSecretApi && api.patch(`${process.env.REACT_APP_API_URI}/api/project_env/secrets`, payload.find((val, idx) => !fromEnvironment ? val.id === currentProject.tasks[selectedAppId].serviceId || idx === data.tempId : (val.id === data.serviceId || val.id === data.tempId)))
    //                     .then((res) => {
    //                         let data = res.data;
    //                         console.log("repo/list data :", data);
    //                         if (data.status) {
    //                             toggleAlert("success", "Success", update ? "Environment variable updated successfully" : "Environment variable added successfully.");
    //                             setHasChanges(false);
    //                             console.log("My var name: ", currentProject.tasks[selectedAppId]?.envs, data);
    //                         }
    //                         else {
    //                             let err = formatErrors(data.msg);
    //                             toggleAlert("error", "Error", err);
    //                         }
    //                         setSavingVars(false);
    //                     })
    //                     .catch((err) => {
    //                         console.log("err :", err);
    //                         toggleAlert("error", "Error", "Something went wrong. Please try again.");
    //                         setSavingVars(false);
    //                     });
    //         if (fromWorkflow) {
    //             // pass
    //         }
    //         else if (!fromEnvironment) {
    //             setActionPerformed(true);
    //         }
    //     }
    // }

    //   const filterOption = (input, option) => {
    //     if (option.key) {
    //       return (option?.value.toLowerCase() ?? '').includes(input.toLowerCase());
    //     }
    //   }

    //   const handleSelectChange = (value, event) => {
    //     console.log("value inside handleSelectChange :", value);
    //     console.log("event inside handleSelectChange :", event);
    //     if (event.name === "value") {
    //       console.log("event alias: ", event);
    //       setEnvData({
    //         ...envData,
    //         [event.name]: event["my-value"],
    //         valueShown: value,
    //         dependOn: event["data-alias"],
    //         error: value ? false : true,
    //       });
    //     }
    //     else {
    //       setEnvData({
    //         ...envData,
    //         [event.name]: value,
    //         value: "",
    //         valueShown: "",
    //         isSecret: value === "Value From" ? false : envData.isSecret,
    //         isHide: value === "Value From" ? false : envData.isSecret,
    //         error: value ? false : true,
    //       });
    //       form.setFieldValue("valueFrom", null);
    //     }
    //     setError({ ...error, status: false });
    //   }

    const onCheckboxChange = (checkedValues) => {
        console.log("On changing check box: ", checkedValues);
        setEnvData({
            ...envData,
            injectAt: checkedValues,
            error: checkedValues.length > 0 ? false : true
        });
    }


    return (
        <ProdContentHold className='addEnvVar' style={{}}>
            {console.log("My env var data: ", envData)}
            <div title={(!hasPermission('update_secret') && update && envData.isSecret) && "You don't have permission to perform this action."}>
                <Form
                    form={form}
                    initialValues={{ ...envData }}
                    preserve={false}
                    name="dynamic_rule"
                    disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                >
                    <Box
                        title={<div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}>
                            <span className="header-text">{update ? "Update Variable" : "Add Variable"}</span>
                            <img src={closeIcon} style={{ cursor: "pointer", width: "20px", height: "20px", transform: "translateY(15px)" }} alt="close Icon" onClick={handelClick} />
                        </div>}
                        subtitle={update ? "Enter details to update variable" : "Enter details to add new variable"}
                        titleStyle={{
                            fontWeight: '500',
                            fontFamily: "Nunito Sans",
                            fontSize: '14px',
                            color: "white"
                        }}
                        subTitleStyle={{
                            fontWeight: '400',
                            fontFamily: "Nunito Sans",
                            fontSize: '13px',
                            color: "white"
                        }}
                        style={{
                            position: "absolute",
                            zIndex: "1",
                            width: "100%",
                            top: "0px",
                            height: "83px",
                            backgroundColor: "rgb(19, 47, 68)"
                        }}
                    />

                    <Box
                        title="Variable*"
                        subtitle="Variable Name"
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{
                            marginTop: "80px",
                        }}
                    >
                        <Form.Item
                            name="varName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter variable name',
                                }
                            ]}
                            style={{ marginBottom: "0" }}
                        >
                            <Input
                                name="varName"
                                value={envData.varName}
                                onChange={handelInputChange}
                                placeholder="Enter Variable here"
                                className="envVar-varName"
                                style={{ height: "44px" }}
                                disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                                data-testid="env-var-name-input"
                            />
                        </Form.Item>
                    </Box>

                    {envData.type && <Box
                        title="Type*"
                        subtitle="Variable type"
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{
                            marginTop: "0px",
                        }}
                    >
                        <Input
                            name="type"
                            value={envData.type}
                            onChange={handelInputChange}
                            placeholder="Enter Variable here"
                            className="envVar-varName"
                            style={{ height: "44px" }}
                            disabled={true}
                        />
                    </Box>}

                    {fromApplicationBlueprint && <Box
                        title="Value From*"
                        subtitle="Value from details"
                        subtitleStyle={subTitleStyle}
                        titleStyle={titleStyle}
                        style={{ width: "100%" }}
                    >
                        <div style={{ width: "100%" }}>
                            <Form.Item
                                name="valueFrom"
                                rules={[
                                    {
                                        required: true,
                                        message: 'This field is required!',
                                    },
                                ]}
                            >
                                <Select
                                    value={envData.valueFrom}
                                    onChange={handleValueFromSelect}
                                    placeholder="Enter Value From here"
                                    style={{ width: '100%' }}
                                    disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                                >
                                    {myValueFroms}
                                </Select>
                            </Form.Item>
                        </div>
                    </Box>}

                    {fromApplicationBlueprint && envData.valueFrom === "Value From" && <Box
                        title="Dependent Service*"
                        subtitle="Select depends on service for this environment variable."
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{
                            marginTop: "0px",
                        }}
                    >
                        <Form.Item
                            name="dependOn"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select a service',
                                }
                            ]}
                        >
                            <Select
                                value={selectedApplicationId}
                                onChange={handleServiceSelect}
                                placeholder="Select Service"
                                style={{ width: '100%' }}
                                loading={applicationsLoading}
                                disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                            >
                                {(applicationsList || [])
                                    .filter((app) => {
                                        if (!excludeDependentApplicationName || !app?.name) {
                                            return true;
                                        }
                                        return (
                                            String(app.name).toLowerCase() !==
                                            String(excludeDependentApplicationName).toLowerCase()
                                        );
                                    })
                                    .map((app) => (
                                        <Option key={app.id} value={app.id}>
                                            {app.name}
                                        </Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Box>}

                    <Box
                        title={envData.valueFrom === "Value From" ? "Select Value*" : "Value*"}
                        subtitle={envData.valueFrom === "Value From" ? "Select dependent service value from dropdown. Values are displayed as <SERVICE_VARIABLE_name>" : "Please enter a value"}
                        subtitleStyle={subTitleStyle}
                        titleStyle={titleStyle}
                    >
                        {console.log("envData.valueShown :", envData.valueShown)}
                        {fromApplicationBlueprint && envData.valueFrom === "Value From" ? (
                            <Form.Item
                                name={envData.valueFrom === "Value From" ? "valueShown" : "value"}
                                rules={[
                                    {
                                        required: true,
                                        message: 'This field is required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    value={envData.valueShown ? envData.valueShown : undefined}
                                    optionLabelProp={envData.valueShown}
                                    onChange={handleSelectChange}
                                    placeholder="Please Select Value"
                                    style={{ width: "100%" }}
                                    disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                                >
                                    {myDropdown}
                                </Select>
                            </Form.Item>
                        ) : (
                            <Form.Item
                                name="value"
                                rules={[
                                    {
                                        required: true,
                                        message: 'This field is required!',
                                    },
                                    {
                                        validator: (_, value) => {
                                            console.log("envData :", envData);
                                            console.log("type :", type);
                                            console.log("value :", value);

                                            if (type === "terraform" && envData.type) {
                                                // const parsed = JSON.parse(value);
                                                if (envData.type === "map(string)" && isValidMapString(value)) {
                                                    return Promise.resolve();
                                                }
                                                else if (envData.type === "list(string)" && isValidListString(value)) {
                                                    return Promise.resolve();
                                                }
                                                else if (envData.type === "map(any)" && isValidMapAny(value)) {
                                                    return Promise.resolve();
                                                }
                                                else if (envData.type === "any") {
                                                    return Promise.resolve();
                                                }
                                                else if (envData.type === "bool" && isValidBool(value)) {
                                                    return Promise.resolve();
                                                }
                                                else if (!["map(any)", "map(string)", "any", "list(string)"].includes(envData.type)) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Value is not matching the type specified.'));
                                            }
                                            else{
                                                return Promise.resolve();
                                            }
                                        }
                                    },
                                ]}
                            >
                                <TextArea
                                    rows={4}
                                    name="value"
                                    value={envData.valueFrom === "Value From" ? envData.valueShown : envData.value}
                                    onChange={handelInputChange}
                                    placeholder="Enter value here"
                                    className="envVar-textarea"
                                    disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                                data-testid="env-var-value-input"
                                />
                            </Form.Item>
                        )}
                    </Box>

                    <Box
                        title={<div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                            <div style={{ display: "flex" }}>
                                <span style={{ marginRight: "10px" }}>Is this a secret* </span>
                                <CustomInfoTooltip title={"Note: any new secret or modification to existing secrets will sync back to the provider."} placement="bottomLeft" />
                            </div>
                            {console.log("Has permission check...", (!hasPermission('create_secret') || (!hasPermission('update_secret') && update)) && data.isSecret)}
                            <Switch
                                checked={envData.isSecret}
                                onChange={(checked) => {
                                    if (!(envData.valueFrom === "Value From")) {
                                        setEnvData({ ...envData, syncProj: false, isSecret: !envData.isSecret, isHide: !envData.isSecret });
                                        setError({ ...error, status: false });
                                    }
                                }}
                                name="isSecret"
                                title={((((!hasPermission('create_secret') && !update) || (!hasPermission('update_secret') && update && data.isSecret)))) ? "You don't have permission to perform this action." : (envData.valueFrom === "Value From") ? "This action is not permitted for the existing variable configuration." : ""}
                                disabled={((!hasPermission('create_secret') && !update) || (!hasPermission('update_secret') && update && data.isSecret))}
                                style={{ backgroundColor: envData.isSecret && "#132f44", opacity: (envData.valueFrom === "Value From") && "0.7", cursor: (envData.valueFrom === "Value From") && "not-allowed" }}
                                data-testid="env-var-secret-toggle"
                            /></div>}
                        subtitle="Toggle the switch to enable secret variable."
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                    >
                    </Box>

                    {(!fromWorkflow || fromApplicationBlueprint) && <Box
                        title="Environment variable type"
                        subtitle="Select environment variable type"
                        subtitleStyle={subTitleStyle}
                        titleStyle={titleStyle}
                        style={{ width: "100%" }}
                    >
                        <Form.Item name="injectAt" rules={[
                            {
                                required: true,
                                message: "Please select environment variable type"
                            }
                        ]}>
                            <Checkbox.Group name="injectAt" value={envData.injectAt} onChange={onCheckboxChange} style={{ marginTop: "15px" }}>
                                <Checkbox 
                                    name="Build Time" 
                                    value={"Build Time"} 
                                    disabled={fromApplicationBlueprint && sourceType === "container"}
                                    style={{ border: "1px solid", padding: "10px", borderRadius: "8px", marginRight: "10px", color: "#1f1f1f !important", padding: "13px" }}
                                >
                                    Build Time
                                </Checkbox>
                                <Checkbox 
                                    name="Run Time" 
                                    value={"Run Time"} 
                                    style={{ border: "1px solid", padding: "10px", borderRadius: "8px", color: "#1f1f1f !important", padding: "13px" }}
                                >
                                    Run Time
                                </Checkbox>
                            </Checkbox.Group>
                        </Form.Item>
                        <ContentHolder style={{ marginTop: "12px" }}>
                            {error.status && <p className="isoHelperText">
                                <span>{error.msg}</span>
                            </p>}
                        </ContentHolder>
                    </Box>}

                    <div style={{ height: "150px" }}></div>


                    <div style={{
                        position: "absolute",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "84px",
                        bottom: "0",
                        borderTop: "1px solid #e9e9e9",
                        zIndex: "1000",
                        background: "white",
                    }}>
                        {!update ?
                            <Button style={{
                                padding: '10px 50px',
                                backgroundColor: "#132F44",
                                width: "164px",
                                height: "44px",
                                border: '1px solid #D9D9D9',
                                borderRadius: '8px',
                                color: "white",
                                marginRight: "15px"
                            }}
                                onClick={(e) => {
                                    handelCreate(e, false);
                                    // handelSaveEnvVar();
                                }}
                                data-testid="env-var-create-btn"
                            >Create</Button>
                            :
                            <Button style={{
                                padding: '10px 50px',
                                backgroundColor: "#132F44",
                                width: "164px",
                                height: "44px",
                                border: '1px solid #D9D9D9',
                                borderRadius: '8px',
                                color: "white",
                            }}
                                onClick={handelUpdate}
                                data-testid="env-var-update-btn"
                            >Update</Button>
                        }

                        {!update && <Button style={{
                            padding: '10px 14px',
                            backgroundColor: "transparent",
                            width: "188px",
                            height: "44px",
                            border: '1px solid #132F44',
                            borderRadius: '8px',
                            color: "#132F44"
                        }}
                            onClick={(e) => {
                                handelCreate(e, true);
                            }}
                            data-testid="env-var-create-and-add-another-btn"
                        >Create & Add another</Button>}
                    </div>
                </Form>
            </div>
        </ProdContentHold >
    );
};